import { Pipe, PipeTransform } from "@angular/core";
import { MyNjHelpsConstants } from "@mynjhelps/common";

@Pipe({
    name: "zip",
    standalone: false
})
export class ZipPipe implements PipeTransform {
  transform(value: any): string {
    if (
      !value ||
      value === MyNjHelpsConstants.NULL_INT ||
      value === MyNjHelpsConstants.NULL_LONG
    ) {
      return "";
    }
    const postalCode = value.toString();
    if (postalCode.length === 9) {
      const zip1 = postalCode.slice(0, 5);
      const zip2 = postalCode.slice(5, postalCode.length);
      const zipCode = zip1 + "-" + zip2;

      return zipCode;
    }

    return value;
  }
}
